// ============================================================================
// Shared download helpers for exporting generated content.
// Nothing is stored server-side; these just save the current result locally.
// ============================================================================

function triggerDownload(url: string, filename: string): void {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** Download plain text as a .txt file. */
export function downloadText(filename: string, text: string): void {
  const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
  triggerDownload(URL.createObjectURL(blob), filename.endsWith('.txt') ? filename : `${filename}.txt`);
}

/** Download arbitrary string content with the given mime type/extension. */
export function downloadBlob(
  filename: string,
  content: string | Blob,
  mime: string = 'text/plain;charset=utf-8'
): void {
  const blob = content instanceof Blob ? content : new Blob([content], { type: mime });
  triggerDownload(URL.createObjectURL(blob), filename);
}

/** Strip HTML tags to plain text (best-effort, for TXT export of rich content). */
export function htmlToPlainText(html: string): string {
  // Drop non-content blocks (e.g. injected <style>/<script>) before parsing.
  const withoutHidden = html.replace(/<(style|script|title)[\s\S]*?<\/\1>/gi, '');
  if (typeof document !== 'undefined') {
    const tmp = document.createElement('div');
    tmp.innerHTML = withoutHidden;
    // Add spacing around block elements so the text isn't one long line.
    tmp.querySelectorAll('h1,h2,h3,h4,h5,h6,p,li,tr,br,hr').forEach((el) => {
      el.append('\n');
      if (['H1', 'H2', 'H3', 'LI'].includes(el.tagName)) el.append('\n');
    });
    return (tmp.textContent || tmp.innerText || '')
      .replace(/[ \t]+\n/g, '\n')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }
  return withoutHidden.replace(/<[^>]+>/g, '').replace(/\n{3,}/g, '\n\n').trim();
}
